import { Component, ElementRef, inject, signal, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuItem as MenuItem } from '@/layout/model/menu-item.model';
import { AppMenuitem } from './app.menuitem';
import { MenuService } from '@/layout/service/menu.service';
import { TranslateService } from '@ngx-translate/core';
import { MsgService } from '@/core/service/msg.service';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, RouterModule, AppMenuitem],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: ` <div class="layout-menu-container" #menuContainer>
        <ul class="layout-menu">
            @for (item of model; track $index) {
                @if (item.separator) {
                    <li class="menu-separator"></li>
                } @else {
                    <li app-menuitem [loading]="loading()" [item]="item" [index]="$index" [root]="true"></li>
                }
            }
        </ul>
    </div>`
})
export class AppMenu {
    el: ElementRef = inject(ElementRef);
    loading = signal<boolean>(false);
    @ViewChild('menuContainer') menuContainer!: ElementRef;
    menus = signal<any[]>([]);
    model: MenuItem[] = [
        {
            label: 'Dashboard',
            icon: 'f-icon dashboard',
            routerLink: ['/dashboard']
        },
        {
            label: 'Onboarding',
            icon: 'ms:home',
            routerLink: ['/case-workflow/onboarding']
        },
        {
            label: 'Watchlist',
            icon: 'f-icon watchlist',
            routerLink: ['/case-workflow/watchlist'],
            items: [
                {
                    label: 'Case Management',
                    icon: 'f-icon case-management',
                    routerLink: ['/case-workflow/watchlist/case-management']
                }
            ]
        },
        {
            label: 'Transaction Screening',
            icon: 'f-icon txn-screening',
            routerLink: ['/case-workflow/transaction-screening'],
            items: [
                {
                    label: 'Case Management',
                    icon: 'f-icon case-management',
                    routerLink: ['/case-workflow/transaction-screening/case-management']
                }
            ]
        },
        {
            label: 'Setting',
            icon: 'f-icon setting',
            routerLink: ['/setting'],
            items: [
                {
                    label: 'Apply License',
                    icon: 'f-icon apply-license',
                    routerLink: ['/setting/application-license']
                },
                {
                    label: 'Application Setting',
                    icon: 'f-icon setting',
                    routerLink: ['/setting/application-setting']
                },
                {
                    label: 'Parameter Setting',
                    icon: 'f-icon parameter-setting',
                    routerLink: ['/setting/parameter-setting']
                },
                {
                    label: 'Setup Workflow',
                    icon: 'f-icon setup-workflow',
                    routerLink: ['/application-setting/setup-workflow']
                },
                {
                    label: 'Setup KYC Mapping',
                    icon: 'f-icon setup-kyc',
                    routerLink: ['/application-setting/setup-kyc-application-setting']
                },
                {
                    label: 'Email Template',
                    icon: 'f-icon email-template',
                    routerLink: ['/application-setting/email-template']
                },
                {
                    label: 'Remark Template',
                    icon: 'f-icon remark-template',
                    routerLink: ['/application-setting/remark-template']
                },
                {
                    label: 'Setup Watchlist Rule',
                    icon: 'f-icon setup-watchlist-rule',
                    routerLink: ['/application-setting/setup-watchlist-rule']
                }
            ]
        },
        {
            label: 'User Management',
            icon: 'f-icon user',
            routerLink: ['/user-management'],
            items: [
                {
                    label: 'User',
                    icon: 'ms:group',
                    routerLink: ['/user-management/user']
                },
                {
                    label: 'User Activities log',
                    icon: 'ms:manage_accounts',
                    routerLink: ['/user-management/user-activities-log']
                },
                {
                    label: 'Role',
                    icon: 'ms:edit',
                    routerLink: ['/user-management/role']
                },
                {
                    label: 'Manage Role',
                    icon: 'ms:sync',
                    routerLink: ['/user-management/manage-role']
                },
                {
                    label: 'Manage Branch',
                    icon: 'ms:account_tree',
                    routerLink: ['/user-management/branch']
                }
            ]
        }
    ];

    constructor(
        private menuService: MenuService,
        private msgService: MsgService,
        private translate: TranslateService
    ) {
        this.translate.onLangChange.subscribe((l) => {
            this.loading.set(true);
            this.getMenus();
        });
    }

    getMenus() {
        this.menuService.getMenuItem().subscribe({
            next: (resp: any) => {
                console.log('res >>> ', resp);
                if (resp.code === 200) {
                    this.menus.set(resp.data.items);
                }
                this.loading.set(false);
            },
            error: (err: any) => {
                this.msgService.error('Fetch menuitem', err.message);
                this.loading.set(false);
            },
            complete: () => {
                this.loading.set(false);
            }
        });
    }
}
